import { render, staticRenderFns } from "./VisitTerms.vue?vue&type=template&id=c66d68c2&scoped=true"
import script from "./VisitTerms.vue?vue&type=script&lang=js"
export * from "./VisitTerms.vue?vue&type=script&lang=js"
import style0 from "./VisitTerms.vue?vue&type=style&index=0&id=c66d68c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66d68c2",
  null
  
)

export default component.exports